import {Switch} from '@material-ui/core';
import React, {ChangeEvent, ReactElement, useState} from 'react';
import {EnvironmentType} from '../../../shared/model/EnvironmentType.model';
import {TransHelper} from '../../../utils/trans-helper';
import styles from './EnvSwitch.module.scss';

interface EnvSwitchProps {
  onChange: (envType: EnvironmentType) => void;
  value?: EnvironmentType;
}

const mapEnvState = (val?: EnvironmentType): boolean => (
  val !== EnvironmentType.SANDBOX
);

const PrefixTrans = TransHelper.getPrefixedTrans('SHARED.ENVIRONMENT');

export default function EnvSwitch({onChange, value}: EnvSwitchProps): ReactElement {

  const [state, setState] = useState({
    checked: mapEnvState(value)
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setState({...state, [event.target.name]: event.target.checked});

    if (event.target.checked) {
      onChange(EnvironmentType.PRODUCTION);
    } else {
      onChange(EnvironmentType.SANDBOX);
    }
  };

  return (
    <div className={styles.container}>
      <div>
        <PrefixTrans>{EnvironmentType.SANDBOX}</PrefixTrans>
      </div>
      <Switch className={styles.switch}
              checked={state.checked}
              onChange={handleChange}
              color='primary'
              name='checked'
              inputProps={{'aria-label': 'Switch environment'}} />
      <div>
        <PrefixTrans>{EnvironmentType.PRODUCTION}</PrefixTrans>
      </div>
    </div>
  );
}
